import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, EntityProc, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { DomiciliosLookups } from "../../Components/Domicilios/DomiciliosColumns";
import { catTiposSolicitudRuta } from "../Categorias y Estados/catTiposSolicitudRuta";
import { Clientes } from "../Clientes/Clientes";
import { Personal } from "../Personal/Personal";
import { RutasTiendasFilters } from "../Rutas/RutasTiendasFilters/RutasTiendasFilters";
import { ACTAutorizarSolicitudRuta } from "./ACTAutorizarSolicitudRuta";
import { ACTCopiarRuta } from "./ACTCopiarRuta";
import { ACTEditarRuta } from "./ACTEditarRuta";
import { ACTEliminarRuta } from "./ACTEliminarRuta";
import { ACTEnviarSolicitudRuta } from "./ACTEnviarSolicitudRuta";
import { ACTExportarClientesRutas } from "./ACTExportarClientesRutas";
import { ACTExportarRutas } from "./ACTExportarRutas";
import { ACTImportarRutas } from "./ACTImportarRutas";
import { ACTReasignarRuta } from "./ACTReasignarRuta";
import { ACTRechazarSolicitudRuta } from "./ACTRechazarSolicitudRuta";
import { ACTVerImportaciones } from "./ACTVerImportaciones";
import { DisponibleEnRutasViewColumnsOverrides } from "./DisponibleEnRutasViewColumnsOverrides";
import { DisponibleEnRutasViewInfoWindowRenderer } from "./DisponibleEnRutasViewInfoWindowRenderer";
import { DisponibleEnRutasViewMarkerRenderer } from "./DisponibleEnRutasViewMarkerRenderer";

const columns = () =>
(
    {
        c_solicitudruteo_id: new EntityColumn<string>({ name: 'c_solicitudruteo_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Solicitud Id' }),
        c_ruta_id: new EntityColumn<string>({ name: 'c_ruta_id', type: 'char', length: 20, flags: c.PK, prompt: 'Ruta Id' }),
        c_tiposolicitudruta_id: new EntityColumn<string>({ name: 'c_tiposolicitudruta_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Tipo' }),
        vc_codigo_ruta_solicitud: new EntityColumn<string>({ name: 'vc_codigo_ruta_solicitud', type: 'varchar', length: 50, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Código Ruta' }),
        d_fechadesde: new EntityColumn<Date>({ name: 'd_fechadesde', type: 'date', flags: c.Edit, prompt: 'Fecha desde' }),
        c_cliente_id: new EntityColumn<string>({ name: 'c_cliente_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Cliente Exclusivo Id' }),
        vc_nombre_ruta_solicitud: new EntityColumn<string>({ name: 'vc_nombre_ruta_solicitud', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre Ruta' }),
        vc_observaciones_solicitud: new EntityColumn<string>({ name: 'vc_observaciones_solicitud', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Observaciones' }),
        c_personal_id: new EntityColumn<string>({ name: 'c_personal_id', type: 'char', length: 20, flags: c.FK, prompt: 'Personal Id' }),
        c_persona_id: new EntityColumn<string>({ name: 'c_persona_id', type: 'char', length: 20, flags: c.FK, prompt: 'Persona Id' }),
        vc_numerodni: new EntityColumn<string>({ name: 'vc_numerodni', type: 'varchar', length: 255, flags: c.Edit, prompt: 'DNI' }),
        vc_nombre: new EntityColumn<string>({ name: 'vc_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre' }),
        vc_apellido: new EntityColumn<string>({ name: 'vc_apellido', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Apellido' }),
        vc_puestotrabajo: new EntityColumn<string>({ name: 'vc_puestotrabajo', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Puesto' }),
        dt_nacimiento: new EntityColumn<Date>({ name: 'dt_nacimiento', type: 'date', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Nacimiento' }),
        vc_genero: new EntityColumn<string>({ name: 'vc_genero', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Género' }),
        vc_fotoguid: new EntityColumn<string>({ name: 'vc_fotoguid', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Foto URL' }),
        vc_superior: new EntityColumn<string>({ name: 'vc_superior', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Superior' }),
        vc_telefono: new EntityColumn<string>({ name: 'vc_telefono', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Teléfono' }),
        vc_celular: new EntityColumn<string>({ name: 'vc_celular', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Celular' }),
        vc_celular_trabajo: new EntityColumn<string>({ name: 'vc_celular_trabajo', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Celular Trabajo' }),
        vc_telefono_alternativo: new EntityColumn<string>({ name: 'vc_telefono_alternativo', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Teléfono Alternativo' }),
        vc_email: new EntityColumn<string>({ name: 'vc_email', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Email' }),
        vc_email_alternativo: new EntityColumn<string>({ name: 'vc_email_alternativo', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Email Alternativo' }),
        f_latitud: new EntityColumn<number>({ name: 'f_latitud', type: 'float', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Latitud' }),
        f_longitud: new EntityColumn<number>({ name: 'f_longitud', type: 'float', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Longitud' }),
        vc_domicilio_completo: new EntityColumn<string>({ name: 'vc_domicilio_completo', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Domicilio Completo' }),
        n_total_horas_semanales: new EntityColumn<number>({ name: 'n_total_horas_semanales', type: 'decimal', scale: 2, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Total Horas Semanales' }),
        n_horas_semanales_disponibles: new EntityColumn<number>({ name: 'n_horas_semanales_disponibles', type: 'decimal', scale: 2, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Horas Semanales Disponibles' }),
        n_horas_semanales_compartidas: new EntityColumn<number>({ name: 'n_horas_semanales_compartidas', type: 'decimal', scale: 2, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Horas Semanales Compartidas' }),
        n_horas_semanales_exclusivas: new EntityColumn<number>({ name: 'n_horas_semanales_exclusivas', type: 'decimal', scale: 2, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Horas Semanales Exclusivas' }),
        dt_fecha_baja: new EntityColumn<Date>({ name: 'dt_fecha_baja', type: 'date', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha Baja' }),
        dt_fecha_alta: new EntityColumn<Date>({ name: 'dt_fecha_alta', type: 'date', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha Alta' }),
        dt_licencia_desde: new EntityColumn<Date>({ name: 'dt_licencia_desde', type: 'date', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Licencia Desde' }),
        dt_licencia_hasta: new EntityColumn<Date>({ name: 'dt_licencia_hasta', type: 'date', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Licencia Hasta' }),
        c_estado_licencia_id: new EntityColumn<string>({ name: 'c_estado_licencia_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Estado Licencia Id' }),
        vc_tiendas: new EntityColumn<string[]>({ name: 'vc_tiendas', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Tiendas', isArray: true }),
        c_autorizacion_id: new EntityColumn<string>({ name: 'c_autorizacion_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Autorizacion Id' }),
        vc_personal_solicitud: new EntityColumn<string>({ name: 'vc_personal_solicitud', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Personal Solicitud' }),
        c_personal_ruta_id: new EntityColumn<string>({ name: 'c_personal_ruta_id', type: 'char', length: 20, flags: c.FK, prompt: 'Personal Ruta Id' }),
        vc_personal_ruta: new EntityColumn<string>({ name: 'vc_personal_ruta', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Personal Ruta' }),
        b_nueva: new EntityColumn<boolean>({ name: 'b_nueva', type: 'bit', flags: EntityColumnFlags.None, prompt: 'Solicitud Nueva' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        soru_brwStandard: { name: 'soru_brwStandard', keyMappings: { c_solicitudruteo_id: 0 } },
        soru_brwBorradores: { name: 'soru_brwBorradores', keyMappings: { c_solicitudruteo_id: 0 } },
        soru_brwHistorial: { name: 'soru_brwHistorial', keyMappings: { c_solicitudruteo_id: 0 } },
        soru_brwDisponibleEnRutas: {
            name: 'soru_brwDisponibleEnRutas', keyMappings: { c_personal_id: 0, c_ruta_id: 26 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new RutasTiendasFilters(client, parentKeys),
            gridColumnsOverrides: DisponibleEnRutasViewColumnsOverrides,
            mapMarkerRenderer: DisponibleEnRutasViewMarkerRenderer,
            mapInfoWindowRenderer: DisponibleEnRutasViewInfoWindowRenderer,
        }
    }
)

const lookups = () =>
(
    {
        'Personal': {
            name: 'Personal',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },

        'TiposSolicitudRuta': {
            name: 'TiposSolicitudRuta',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catTiposSolicitudRuta(client, parentKeys)
        },

        'Clientes': {
            name: 'Clientes',
            viewMapping: { keyIndex: 0, descriptionIndex: 2 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Clientes(client, parentKeys),
        },

        ...DomiciliosLookups()
    }
)

const procs = () =>
(
    {
        soru_CrearSolicitudModificacion: { name: 'soru_CrearSolicitudModificacion' },
        soru_EliminarNoModificada: { name: 'soru_EliminarNoModificada' },
        soru_Enviar: { name: 'soru_Enviar' },
        soru_Autorizar: { name: 'soru_Autorizar' },
        soru_Rechazar: { name: 'soru_Rechazar' },
        soru_CrearSolicitudesReasignacion: {
            name: 'soru_CrearSolicitudesReasignacion', parms: { c_personal_origen_id: '', c_personal_destino_id: '' } 
        } as EntityProc,
        soru_CrearSolicitudCopiar: {
            name: 'soru_CrearSolicitudCopiar', parms: { c_personal_origen_id: '', c_personal_destino_id: '' } 
        } as EntityProc
    }
)

const clientActions = () =>
(
    {
        ACTAutorizarSolicitudRuta: ACTAutorizarSolicitudRuta,
        ACTRechazarSolicitudRuta: ACTRechazarSolicitudRuta,
        ACTEnviarSolicitudRuta: ACTEnviarSolicitudRuta,
        ACTEditarRuta: ACTEditarRuta,
        ACTEliminarRuta: ACTEliminarRuta,
        ACTReasignarRuta: ACTReasignarRuta,
        ACTCopiarRuta: ACTCopiarRuta,
        ACTExportarRutas: ACTExportarRutas,
        ACTImportarRutas: ACTImportarRutas,
        ACTVerImportaciones: ACTVerImportaciones,
        ACTExportarClientesRutas: ACTExportarClientesRutas
    }
)

export class SolicitudesRuteoDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    procs = procs();
    clientActions = clientActions();

    constructor() {
        super('SolicitudesRuteo');
    }
}